<div class="navbar-container">
  <div class="spp-navbar">
    <ul class="nav-list">
      <img (click)="navigateToRoot()" [src]="'assets/logo/purple/spp-logo.svg'" alt="logo" i18n-alt class="nav-logo" />
      <li *ngFor="let navItem of navItems$ | async">
        <app-nav-item *ngIf="navItem | isDefaultNavItem" [navItem]="navItem" />
        <app-profile-nav-item *ngIf="navItem | isProfileNavItem" [navItem]="navItem" />
        <app-sign-out-nav-item *ngIf="navItem | isSignOutNavItem" [navItem]="navItem" />
        <app-drop-down-nav-item *ngIf="navItem | isDropDownNavItem" [navItem]="navItem" />
      </li>
    </ul>
  </div>
</div>
